<mat-card>
    <mat-card-header>
        <mat-card-title>Cadastrar Cliente</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <form [formGroup]="clienteForm">

            <div class="row mt-4">
                <div class="col-sm">
                    <mat-radio-group formControlName="tipoCadastro" aria-label="Selecione uma opção"
                        style="margin-left: 10px;" (change)=onChangeTipoCadastro()>
                        <mat-radio-button value="pessoaFisica">Pessoa Física</mat-radio-button>
                        <mat-radio-button value="pessoaJuridica">Pessoa Jurídica</mat-radio-button>
                        <mat-radio-button value="produtorRural">Produtor Rural</mat-radio-button>
                        <!-- <mat-radio-button value="rapidos">Rápidos</mat-radio-button> -->
                    </mat-radio-group>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm">
                    <mat-divider></mat-divider>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-3">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Nome</mat-label>
                        <input type="text" matInput formControlName="nome" maxlength="50" required>
                        <mat-error *ngIf="f.nome.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-2">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Telefone</mat-label>
                        <input type="text" matInput formControlName="telefone" [textMask]="{mask: maskTelefone}"
                            (ngModelChange)="onChangeTel($event, true)" required>
                        <mat-error *ngIf="f.telefone.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.telefone.errors?.telefoneValido">
                            Telefone inválido
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-2">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Telefone Secundário</mat-label>
                        <input type="text" matInput formControlName="telefoneSecundario"
                            [textMask]="{mask: maskTelefone2}" (ngModelChange)="onChangeTel($event, false)">
                    </mat-form-field>
                </div>

                <div class="col-sm-2" *ngIf="f.tipoCadastro.value !== 'pessoaJuridica'">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>CPF</mat-label>
                        <input type="text" matInput formControlName="cpf" maxlength="100"
                            [textMask]="{mask: maskCPF, guide:false}" required>
                        <mat-error *ngIf="f.cpf.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.cpf.errors?.cpfValido">
                            CPF inválido
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-2">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Limite de crédito</mat-label>
                        <input matInput formControlName="credito" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                        <mat-error *ngIf="f.credito.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="f.credito.errors?.min">
                            O valor de crédito deve ser maior que R$ 0,00
                        </mat-error>
                        <mat-error *ngIf="f.credito.errors?.max">
                            O valor de crédito não pode ser maior que R$ 2.000.000,00
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-3">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Responsável atual pelas compras</mat-label>
                        <input type="text" matInput formControlName="responsavelCompra" maxlength="50">
                        <mat-error *ngIf="f.responsavelCompra.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-3">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Prazo nota (dias)</mat-label>
                        <input type="number" matInput formControlName="prazoNota" required>
                        <mat-error *ngIf="f.prazoNota.errors">
                            Campo obrigatório (mínimo 1 dia)
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <div class="custom-checkbox custom-control">
                        <input type="checkbox" formControlName="bCompraBoleto" id="compra_boleto"
                            class="custom-control-input">
                        <label for="compra_boleto" class="custom-control-label">
                            <div style="margin-top: 3px;">Comprar com boleto</div>
                        </label>
                    </div>
                </div>

                <div class="col-auto">
                    <div class="custom-checkbox custom-control">
                        <input type="checkbox" formControlName="bCompraCheque" id="compra_cheque"
                            class="custom-control-input">
                        <label for="compra_cheque" class="custom-control-label">
                            <div style="margin-top: 3px;">Comprar com cheque</div>
                        </label>
                    </div>
                </div>

                <div class="col-auto">
                    <div class="custom-checkbox custom-control">
                        <input type="checkbox" formControlName="bCompraNota" id="compra_nota"
                            class="custom-control-input">
                        <label for="compra_nota" class="custom-control-label">
                            <div style="margin-top: 3px;">Comprar com nota</div>
                        </label>
                    </div>
                </div>
            </div>

            <div class="row mt-2"
                *ngIf="f.tipoCadastro.value === 'pessoaJuridica' || f.tipoCadastro.value ==='produtorRural'">
                <div class="col-auto">
                    <h1 class="customH1">Dados da Empresa</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="row"
                *ngIf="f.tipoCadastro.value === 'pessoaJuridica' || f.tipoCadastro.value ==='produtorRural'">
                <div class="col-auto" *ngIf="f.tipoCadastro.value === 'pessoaJuridica'">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>CNPJ</mat-label>
                        <input type="text" matInput formControlName="cnpj" [textMask]="{mask: maskCNPJ, guide:false}"
                            required>
                        <mat-error *ngIf="f.cnpj.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="!f.cnpj.errors?.cnpjVerdadeiro">
                            CNPJ informado não é válido
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-3" *ngIf="f.tipoCadastro.value === 'pessoaJuridica'">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Razão Social</mat-label>
                        <input type="text" matInput formControlName="razaoSocial" required maxlength="100">
                        <mat-error *ngIf="f.razaoSocial.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Inscrição Estadual</mat-label>
                        <input type="text" matInput formControlName="inscricaoEstadual" required maxlength="50">
                        <mat-hint align="end" *ngIf="f.tipoCadastro.value !== 'produtorRural'">Em caso de isenção,
                            informar: "Isento"</mat-hint>
                        <mat-error *ngIf="f.inscricaoEstadual.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-auto">
                    <h1 class="customH1">Endereço</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">
                <div class="row">
                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'" style="width: 150px;">
                            <mat-label>CEP</mat-label>
                            <input type="text" matInput formControlName="cep" maxlength="10"
                                (ngModelChange)="buscarCEP()" [textMask]="{mask: maskCEP, guide:false}" required>
                            <mat-error *ngIf="f.cep.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-auto col-md-8">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Logradouro</mat-label>
                            <input type="text" matInput formControlName="logradouro" maxlength="100" required>
                            <mat-error *ngIf="f.logradouro.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Número</mat-label>
                            <input type="text" matInput formControlName="numero" maxlength="20" required>
                            <mat-error *ngIf="f.numero.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-auto col-md-3">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Complemento</mat-label>
                            <input type="text" matInput formControlName="complemento" maxlength="100">
                            <mat-error *ngIf="f.complemento.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-auto col-md-4">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Bairro</mat-label>
                            <input type="text" matInput formControlName="bairro" maxlength="30" required>
                            <mat-error *ngIf="f.bairro.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-auto col-md-3">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Cidade</mat-label>
                            <input type="text" matInput formControlName="cidade" maxlength="30" required>
                            <mat-hint>O nome da cidade deve ser idêntico ao cadastrado no sistema</mat-hint>
                            <mat-error *ngIf="f.cidade.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-auto col-md-2">
                        <mat-form-field appearance="outline" [floatLabel]="'always'" style="width: 100px;">
                            <mat-label>UF</mat-label>
                            <input type="text" matInput formControlName="uf" maxlength="2" (keyup)="upperCase($event)"
                                required>
                            <mat-error *ngIf="f.uf.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Referência</mat-label>
                            <input type="text" matInput formControlName="referencia" maxlength="180">
                            <mat-error *ngIf="f.referencia.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Latitude</mat-label>
                            <input type="text" matInput formControlName="latitude" required>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Longitude</mat-label>
                            <input type="text" matInput formControlName="longitude" required>
                        </mat-form-field>
                    </div>

                    <div class="col-auto" *ngIf="bErroLatLng">
                        <button mat-flat-button color="warn" class="mt-4" (click)="buscarLatLng()">
                            <mat-icon>location_on</mat-icon> Buscar coordenadas
                        </button>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Descontos personalizados por grupos promocionais</h1>
                </div>
                <div class="col-auto">
                    <button class="bt_lateral" mat-icon-button color="primary"
                        aria-label="Adicionar produto com desconto" (click)="adicionarProdutoDesconto()">
                        <mat-icon class="mat-icon-custom">control_point</mat-icon>
                    </button>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="row">
                <div class="col-sm">
                    <table mat-table [dataSource]="produtosDescontoSource" class="mat-elevation-z2">

                        <ng-container matColumnDef="Nome">
                            <th mat-header-cell *matHeaderCellDef> Nome </th>
                            <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Produtos">
                            <th mat-header-cell *matHeaderCellDef> Produtos </th>
                            <td mat-cell *matCellDef="let element"> {{element.ProdutosString}} </td>
                        </ng-container>

                        <ng-container matColumnDef="QuantidadeMinima">
                            <th mat-header-cell *matHeaderCellDef> Quantidade mínima </th>
                            <td mat-cell *matCellDef="let element"> {{element.QuantidadeMinima}} </td>
                        </ng-container>

                        <ng-container matColumnDef="PorcentagemDesconto">
                            <th mat-header-cell *matHeaderCellDef> Desconto % </th>
                            <td mat-cell *matCellDef="let element"> {{element.PorcentagemDesconto}} % </td>
                        </ng-container>


                        <ng-container matColumnDef="Remover">
                            <th mat-header-cell *matHeaderCellDef> Remover </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button matTooltip="Remover" (click)="removerDescontoProduto(element)"
                                    class="iconbutton" color="primary">
                                    <mat-icon aria-label="Remover">close</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>

                        <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="5" style="text-align: center;">Não há produtos com descontos
                                cadastrados para este cliente
                            </td>
                        </tr>
                    </table>
                </div>
            </div>


            <div class="row">

                <div class="col-sm-4">
                    <div class="row mt-4">
                        <div class="col-auto">
                            <h1 class="customH1">Vendedor Responsável</h1>
                        </div>
                        <div class="col-sm">
                            <hr />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm">
                            <mat-form-field appearance="fill" [floatLabel]="'always'">
                                <mat-label>Vendedor</mat-label>
                                <mat-select formControlName="idVendedor" name="gp" required>
                                    <mat-option *ngFor="let vendedor of vendedores" [value]="vendedor.value">
                                        {{vendedor.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="f.idVendedor.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="col-sm">

                    <div class="row mt-4">
                        <div class="col-auto">
                            <h1 class="customH1">Dados de Acesso</h1>
                        </div>
                        <div class="col-sm">
                            <hr />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-4">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>E-mail</mat-label>
                                <input type="text" matInput formControlName="email" maxlength="50" required
                                    (keypress)="omit_special_char($event)">
                                <mat-hint>A senha de acesso inicial será o CPF ou CNPJ (somente números)</mat-hint>
                                <mat-error *ngIf="f.email.errors">
                                    Campo obrigatório
                                </mat-error>
                                <!-- <mat-error *ngIf="f.email.errors?.required">
                                    Campo obrigatório
                                </mat-error>
                                <mat-error *ngIf="f.email.errors?.email">
                                    Este e-mail não é válido
                                </mat-error> -->
                            </mat-form-field>
                        </div>

                        <div class="col-auto">
                            <mat-form-field appearance="fill" [floatLabel]="'always'">
                                <mat-label>@email</mat-label>
                                <mat-select formControlName="sComplementoEmail">
                                    <mat-option *ngFor="let tipo of aComplementosEmail" [value]="tipo">
                                        {{tipo}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="f.sComplementoEmail.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-auto">
                            <mat-form-field appearance="fill" [floatLabel]="'always'">
                                <mat-label>.com(.br)</mat-label>
                                <mat-select formControlName="sFinalEmail">
                                    <mat-option *ngFor="let tipo of aFinalEmail" [value]="tipo">
                                        {{tipo}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="f.sFinalEmail.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

            </div>

        </form>
    </mat-card-content>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="limparCampos()">
            <mat-icon>clear</mat-icon> Limpar Campos
        </button>
        <button *ngIf="bPermissaoCadastrar" mat-flat-button color="primary" (click)="cadastrar()">
            <mat-icon>check</mat-icon> Cadastrar
        </button>
    </section>
</mat-card>